<template>
  <div :tabindex="[tabindex]" class="grid-item rounded-lg" ref="compWidget" :class="[size]">
    <div  class="shakeAble h-full " :class="movable ? 'shake' : ''">
      <div class="bg-white shadow rounded-lg h-full">
        <div>
          <div class="flex flex-row justify-between pt-6 px-4 ">
            <div class="flex flex-row justify-start z-20 w-fit  ">
              <dt ref="titleElement" class="flex flex-row text-base font-bold w-fit text-xl text-gray-900">{{ widgetTitle }}</dt>

              <div class="tooltipcomponent tooltipWideWidget w-fit mt-1.5 ml-2 mr-6  ">
                <svg xmlns="http://www.w3.org/2000/svg" class=" h-5 w-5 text-gray-500 fill-current" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
                <p class="tooltiptext absolute -ml-28">{{info}}</p>
              </div>

            </div>

            <widget-settings @clickedRemove="removeWidget($event)" @clickedMove="moveWidgets($event)" :movable="movable" :show-options="options"></widget-settings>
          </div>

          <div v-if="pills.length > 1">

            <div v-if="!pillsUnder">
              <div v-show="loaded" class="hidden sm:block -mt-8">
                <nav class="flex justify-end mr-12 space-x-4 z-30" ref="pillsDOM" aria-label="Tabs">
                  <template v-for="pill in props.pills" :key="pill.id" >
                    <button :value="pill.source"  @click.prevent="selectDataset($event.target)"  :class="pill.selected ? 'tableTab px-3 py-1.5 selected font-medium text-sm rounded-md pillText pillBackground  ' : 'tableTab hover:ring-2 text-gray-500 hover:text-gray-700 px-3 py-1.5 font-medium text-sm rounded-md'">
                      {{ pill.label }}</button>
                  </template>
                </nav>
              </div>
              <div v-show="! loaded" class="hidden sm:block ml-20  -mt-8">
                <nav class="flex justify-end mr-12 space-x-4 z-30" ref="pillsDOM" aria-label="Tabs">
                  <template v-for="pill in props.pills" :key="pill.id" >
                    <button :value="pill.source"  class="cursor-default skeleton tableTab px-8 py-4 selected font-medium text-sm rounded-md bg-gray-400"></button>
                  </template>
                </nav>
              </div>
            </div>

            <div v-else class="px-4">
              <div v-show="loaded">
                <nav class="flex  mt-2 flex-row " :class="props.pills.length >2? 'justify-between':'justify-around'" ref="pillsDOM" aria-label="Tabs">
                  <template v-for="pill in props.pills" :key="pill.id" >
                    <button :value="pill.source"  @click.prevent="selectDataset($event.target)"  :class="pill.selected ? 'px-3 py-1.5 selected font-medium text-sm rounded-md pillText pillBackground ': ' hover:ring-2 text-gray-500 hover:text-gray-700 py-1.5 font-medium text-xs rounded-md' + pillHoverSize">
                      {{ pill.label }}</button>
                  </template>
                </nav>
              </div>
              <div v-show="! loaded">
                <nav class="flex  mt-2 flex-row " :class="props.pills.length > 2? 'justify-between':'justify-around'" ref="pillsDOM" aria-label="Tabs">
                  <template v-for="pill in props.pills" :key="pill.id" >
                    <button :value="pill.source"  class="cursor-default skeleton tableTab py-4 selected font-medium text-sm rounded-md bg-gray-400 " :class="props.widgetType === 'TOP_SEARCH_TERMS'?  ' px-5 ' : ' px-8 '"></button>
                  </template>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!dataIsLoaded" class="flex h-full items-center justify-center" :class="hasLongTitle? ' -mt-8 ': ''">
          <div class="loader loader--style3">
            <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 50 50"  xml:space="preserve">
              <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
              </path>
            </svg>
          </div>
        </div>

        <component v-show="dataIsLoaded"
              @dataLoaded="dataLoaded"
              @dataUnloaded="dataUnloaded"
              :is="currentComponent"
              :update="update"
              :source="pillSource"
              :style="style"
              :colorPalette="colorPalette"
              :pills="pills"
              :type="type"
              :hasLongTitle="textTooLong(props.name, 101) && (props.style.size === '1x1' || props.style.size === '1x2' || width === ''  )">

          </component>
      </div>
    </div>
  </div>
</template>


<script setup>
import {defineEmits, defineProps, markRaw, onMounted, ref, watch} from "vue";
import ChartContent from "@/widgetContent/ChartContent";
import LicenseInfoContent from "@/widgetContent/LicenseInfoContent";
import TopCategories from "@/widgetContent/TopCategories";
import SynchronisationIssues from "@/widgetContent/SynchronisationIssues";
import ConversionRate from "@/widgetContent/ConversionRate";
import TopProducts from "@/widgetContent/TopProducts";
import CatalogQuality from "@/widgetContent/CatalogQuality";
import AccountsInfo from "@/widgetContent/AccountsInfo";
import TopCountries from "@/widgetContent/TopCountries";
import PieChartWidget from "@/widgetContent/PieChartWidget";
import ReturningCustomers from "@/widgetContent/ReturningCustomers";
import TopClients from "@/widgetContent/TopClients";
import TopSearchTerms from "@/widgetContent/TopSearchTerms";
import SunburstChart from "@/widgetContent/charts/SunburstChart";
import HeatmapChart from "@/widgetContent/charts/HeatmapChart";
import WidgetSettings from "@/widgets/WidgetSettings";
import TopBrands from "@/widgetContent/TopBrands";
import PageviewWidget from "@/widgetContent/PageviewWidget";
import PageVisitWidget from "@/widgetContent/PageVisitWidget";

let emit = defineEmits(["clickedMove", "clickedRemove"]);
let props = defineProps({
  update: Number,
  movable: Boolean,
  widget: Object,
  options: Boolean,
  source: String,
  style: Object,
  name: String,
  widgetType: String,
  tabindex: Number,
  pills: Array,
  colorPalette: Object,
  info: String
})

let pillSource = ref()
let type = ref("");
let size = ref("");
let showOptions = ref(false);
let showMovable = ref(false);
let loaded = ref(false);
let titleElement = ref(null);
let title = ref();
let currentComponent = ref();
let totalPillsLength = ref();
let pillsDOM = ref(null);
let pillHoverSize = ref(" px-3 ");
let dataIsLoaded = ref(false);
let hasLongTitle = ref();
watch(() => props.update, async () => {
  loaded.value = false;
})

let pillsUnder = ref(true);
let widgetTitle = ref(props.name)
onMounted(() => {
  if (props.widgetType === 'TOP_PRODUCTS'){
    if (screen.width >= 625){
      pillsUnder.value = false

  }}
  if (screen.width < 625){
    if ( widgetTitle.value === "Synchronisatieproblemen"){
      widgetTitle.value = "Synchronisatie problemen"
    } else if (widgetTitle.value === "Synchronisationsprobleme"){
       widgetTitle.value = "Synchronisations probleme"

    }
  }
  size.value = getSize(props.style.size)
  type.value = props.widgetType;
  title.value = props.name;
  let pillLength= "";
  currentComponent.value = getCurrentComponent(type.value)
  hasLongTitle.value = textTooLong(props.name, 101) && (props.style.size === '1x1' || props.style.size === '1x2' || width.value=== ''  )
  if (props.pills.length > 0 ){
    props.pills.forEach(el => {
      pillLength += el.label
      totalPillsLength.value += el.label.length
      if (el.selected === true)
      {
        pillSource.value = el.source
      }
    });
    if (textTooLong(pillLength, 150)){
      pillHoverSize.value = " px-1  "
    } else if(textTooLong(pillLength, 140)){
      pillHoverSize.value = " px-2 "
    }
  }
  else{
    pillSource.value = props.source
  }
  loaded.value = true
})

function selectDataset(e)
{
  if (! e.classList.contains("selected"))
  {
    loaded.value = false
    e.classList = "selected px-3 py-1.5 font-medium text-sm rounded-md pillText pillBackground";
    getSiblings(e).forEach(el =>
        el.classList = "text-gray-500 hover:ring-2 hover:text-gray-700 py-1.5 font-medium text-xs rounded-md " + pillHoverSize.value
    )
    pillSource.value = e.value;
  }
}

function getSiblings(e)
{
  let siblings = [];
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }
  return siblings;
}

function dataLoaded(){
  loaded.value = true
  dataIsLoaded.value = true;
}
function dataUnloaded(){
  dataIsLoaded.value = false;
}

function moveWidgets() {
  showMovable.value = true;
  showOptions.value = false;
  emit("clickedMove", showMovable.value, showOptions.value);
}
function removeWidget(e) {
  emit("clickedRemove", [e, props.widget]);
}

function getTextWidth(text) {
  // if given, use cached canvas for better performance
  // else, create new canvas
  let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  let context = canvas.getContext("2d");
  let metrics = context.measureText(text);
  return metrics.width;
}

function textTooLong(text, limit){
  let textWidth = getTextWidth(text);
  return textWidth > limit;
}
let width = ref(" grid-item--width2 ")
function getSize(size){
  // let height = " ";
  if (screen.width < 625){
    width.value = ""
    // height = " grid-item--height2 "
  }
  // Make pagevisitwidget always use grid-item--width2
  if (props.widgetType === 'PAGE_VISIT_WIDGET') {
    return " grid-item--width3 grid-item--height3 ";
  }
  if (size === "2x1") {
    return width.value;
  } else if (size === "1x2") {
    return "grid-item--height2 ";
  } else if (size === "2x2") {
    return "grid-item--height2 " + width.value;
  } else {
    return "";
  }
}


function getCurrentComponent(type) {
  switch (type) {
    case 'CHART_CONTENT':
    case 'TOTAL_SALES':
    case 'LOGIN_ACTIVITY':
    case 'TOTAL_ORDERS':
    case 'TOTAL_VISITS':
    case 'AVERAGE_ORDER_VALUE':
      return markRaw(ChartContent)
    case 'CATEGORIES_SUNBURST':
      return markRaw(SunburstChart)
    case 'TOP_PRODUCTS':
      return markRaw(TopProducts)
    case 'TOP_LANGUAGES':
      return markRaw(PieChartWidget)
    case 'SYNCHRONISATION_ISSUES':
      return markRaw(SynchronisationIssues)
    case 'TOP_CLIENTS':
      return markRaw(TopClients)
    case 'TOP_SEARCH_TERMS':
      return markRaw(TopSearchTerms)
    case 'ORDERS_HEATMAP':
      return markRaw(HeatmapChart)
    case 'TOP_COUNTRIES':
      return markRaw(TopCountries)
    case 'TOP_BRANDS':
      return markRaw(TopBrands)
    case 'TOP_CATEGORIES':
      return markRaw(TopCategories)
    case 'LICENSE_INFO':
      return markRaw(LicenseInfoContent)
    case 'CONVERSION_RATE':
      return markRaw(ConversionRate)
    case 'CATALOG_QUALITY':
      return markRaw(CatalogQuality)
    case 'ACCOUNTS_INFO':
      return markRaw(AccountsInfo)
    case 'RETURNING_CUSTOMERS':
      return markRaw(ReturningCustomers)
    case 'DELIVERY_TYPE':
      return markRaw(PieChartWidget)
    case 'PAGEVIEW_WIDGET':
      return markRaw(PageviewWidget)
    case 'PAGE_VISIT_WIDGET':
      return markRaw(PageVisitWidget)
    default:
      return ''
  }
}
</script>

<style>
.tooltipcomponent {
  position: relative;
  display: inline-block;
}

.tooltipcomponent .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: gray;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  z-index: 1;

  /* Fade in tooltip - takes 1 second to go from 0% to 100% opac: */
  opacity: 0;
  transition: opacity 0.5s;
}


/*.tooltipWideWidget .tooltiptextWideWidget {*/
/*  left: 30%;*/
/*  top: -3rem;*/
/*}*/

.tooltipcomponent:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
